<template>
  <div>
  <v-app>
  <v-container>
    <v-layout row align-center justify-center>
      <v-flex xs8>
          <v-card flat>
            <v-card-title primary-title>
              <h3 class="headline mb-2">Reset Password</h3>
            </v-card-title>
            <v-card-text v-if="!tokenValid">
              <v-alert :value="true" color="error"> {{ tokenInvalidMessage }} </v-alert>
            </v-card-text>
            
             <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field 
                  name="email" 
                  label="Username" 
                  v-model="user.email"
                  readonly
                  required>
                </v-text-field>
                <v-text-field 
                  name="password" 
                  label="Password" 
                  v-model="user.password"
                  :type="'password'"
                  :rules="passwordRules" 
                  required>
                </v-text-field>

                <v-list v-if="passwordValidationError">
                    <template v-for="(item, index) in passwordErrors">
                      <v-list-tile color="error">
                        <v-list-tile-content>
                          {{ item }}
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                </v-list>

                <v-text-field 
                  name="confirmPassword" 
                  label="Confirm Password" 
                  v-model="user.confirmPassword"
                  :type="'password'"
                  :rules="confirmPasswordRules" 
                  required>
                </v-text-field>

              
             <v-card-actions>
                <v-btn @click="resetPassword" primary>Submit</v-btn>
             </v-card-actions>
            </v-form>     
          </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  </v-app>
 </div>
</template>
<script>
import axios from 'axios'
import config from '../config'
import store from '../store'

export default {
  name: 'PasswordReset',
  data: function() {
    return {
      section: 'PasswordReset',
      confirmToken: '',
      response: '',
      tokenValid: true,
      tokenInvalidMessage: '',
      user: {
        'email': '',
        'password': '',
        'confirmPassword': ''
      },
      valid: false,
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length > 7) || 'Password length should be atleast 8 characters'
      ],
      confirmPasswordRules: [
        v => !!v || 'Confirm Password Field is required',
        v => (v && v === this.user.password) || 'Confirm Password must match password field'
      ],
      passwordValidationError: false,
      passwordErrors: []
    }
  },
  mounted () {
    var urlString = window.location.href
    var url = new URL(urlString)
    var t = url.searchParams.get('token')
    this.resetToken = t
    console.log(t)
    this.getPasswordResetTokenDetails()
  },
  methods: {
    getPasswordResetTokenDetails() {
      var url = config.serverURI + '/confirm/passwordreset?token=' + this.resetToken
      console.log(url)
      axios
        .get(url)
        .then(response => {
          var data = response.data

          if (data.error === true) {
            this.tokenValid = false
            this.tokenInvalidMessage = data.message
            console.log(this.tokenInvalidMessage)
            return
          }
          this.user.email = data.message
          console.log(data)
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)

          this.tokenInvalidMessage = 'Server appears to be offline'
          this.toggleLoading()
        })
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    },
    resetResponse() {
      this.response = ''
    },
    resetPassword() {
      this.message = ''
      this.error = ''
      this.passwordErrors = []
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/confirm/resetPassword'
        var token = store.state.token
        axios.post(url, this.user, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            if (response.data.valid === false) {
              this.passwordErrors = response.data.passwordErrors
              console.log('Error is ' + this.passwordErrors)
              this.passwordValidationError = true
              return
            }
            if (response.data.error !== false) {
              this.tokenValid = false
              this.tokenInvalidMessage = response.data.message
              return
            } else {
              window.location = '/login?message=' + response.data.message
            }

            this.resetUserObject()
            this.$refs.form.reset()
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
          })
      }
    }
  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// passwordreset.vue?717b7e06